// extracted by mini-css-extract-plugin
export default {"list":"statistics_list__Co5Uj","item":"statistics_item__27lDu"};